var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M481.5 0c-3.25 0-6.375 .5-9.25 1.5l-290.9 96C168.8 101.8 160 114 160 128v244.8C143 360 120.7 352 95.1 352C42.1 352 0 387.8 0 432S42.1 512 95.1 512s95.1-35.7 95.1-79.95L192 256l288-96v148.8C463 296 440.7 288 415.1 288c-53 0-95.1 35.75-95.1 79.1s42.1 79.1 95.1 79.1s95.1-35.75 95.1-80L512 31.99C512 13.74 497.8 0 481.5 0zM96 480c-34.75 0-64-21.1-64-48C32 406 61.25 384 96 384s64 22 64 48C160 458 130.8 480 96 480zM416 416c-34.75 0-64-21.1-64-48c0-25.1 29.25-48 64-48s64 22 64 48C480 394 450.8 416 416 416zM480 126.2l-288 96V128H191.5L480 32.62V126.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.8e50f84f9b0825f7298bb49f2587c5d0.svg";
export { ForwardRef as ReactComponent };